class GnlOrganizasyonDTO {
    id?: number = 0;
    treekey?: string = "";
    adi?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    bagliId?: number = null;
    aktif?: string = "E";
    aktifBool?: boolean = false;
    seviye?: number = null;
    kurumId?: number = null;
    kurumTarifeId?: number = null;
    disBarkodVar?: string = "H";
    tip?: number = null;
    videoUrl?: string = "";
    hastaborckontrol?: string = "1";
    disbarkodkaraktersayisi?: number = null;
    sadeceKendiHastalari?: string = "H";
    farkliparabirimleriodemeaktif?: string = "H";
    parabirimiGoster?: string = "E";
    mailAddress?: string = "";
    mailDisplayname?: string = "";
    mailHost?: string = "";
    mailPort?: number = null;
    mailUsername?: string = "";
    mailPassword?: string = "";
    mailSsl?: string = "E";
    mailIcerikHtml?: string = "H";
    kurGoster?: string = "H";
    roundyuvarlama?: number = null;
    tipId?: number = null;
    icmalParaBirimId?: number = null;
    mahal?: string = "";
}
export default GnlOrganizasyonDTO;